import React from 'react';
import { useState } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import {ExpandMoreOutlined} from '@material-ui/icons';
import * as loggingUtils from './utils/loggingUtils';
import * as encryptUtils from "./encryptDecryptUtils";
import './BondingCurveAccordion.css';


function BondingCurveAccordion(props) {
  const [current, setCurrent] = useState(-1);

  const changeState = (panel) => (e, newValue) => {
    loggingUtils.logEvent(
      props.address != null
        ? props.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "videos",
      newValue ? "videos_bonding_curve_accordion_expand" : "videos_bonding_curve_accordion_collapse",
      "info",
      "https://the402.xyz",
      {
        index: newValue ? panel : -1
      }
    );
    setCurrent(newValue ? panel : -1);
  }

  return (
    <div>
      <Accordion expanded = {current === 0} onChange = {changeState(0)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
              What device can I watch livestreams on?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          You can watch on both desktop and mobile but only desktop has chat and emotes, so we recommend watching on desktop.
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 1} onChange = {changeState(1)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
              How do I access the livestream if I purchased with credit card?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
        If you bought an NFT with credit card all you need to do is visit the livestream page at the time of the stream. If you wiped your history you will need to re-enter your email below the buy & sell button.
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 2} onChange = {changeState(2)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
              What is a bonding curve?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
        The core concept of a bonding curve is that the price of an NFT is determined by its supply. The more NFTs that have been distributed, the higher the price. The fewer NFTs, the lower the price
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 3} onChange = {changeState(3)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div >
              What happens when you buy and sell an NFT?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
        Simply put, when you by an NFT, the price of the next NFT goes up and when you sell an NFT, the price of the NFT goes down
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 4} onChange = {changeState(4)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
        <div className = "flex items-center">
          <div>
          How is it possible to be able to buy and sell NFTs instantly?
          </div>
        </div>
        </AccordionSummary>
        <AccordionDetails>
        When you buy an NFT, the money used to purchase that NFT is stored in the contract (you can think of this as a cash register).
        If you would like to sell back the NFT, you would burn “or return” the NFT and the contract would give you back the amount ~based on the current market price~ of the NFT
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 5} onChange = {changeState(5)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
        <div className = "flex items-center">
          <div>
          How long can you buy and sell NFTs instantly for?
          </div>
        </div>
        </AccordionSummary>
        <AccordionDetails>
        You can buy and sell NFTs instantly during a period of time set by the creator (called the liquidity period).
        This period of time is fixed and cannot be changed in the future.
        If the creator sets the liquidity period to be infinite, you can always buy and sell forever

        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 6} onChange = {changeState(6)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
            How do creators make money?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
        During the liquidity period, creators make money off of buy and sell transaction fees - these are called the “Creator Fees”
        Once the liquidity period is over, the creator receives the funds stored in the contract that was previously being used to provide liquidity
        </AccordionDetails>
      </Accordion>
      <Accordion expanded = {current === 7} onChange = {changeState(7)}>
        <AccordionSummary expandIcon = {<ExpandMoreOutlined/>}>
          <div className = "flex items-center">
            <div>
            Can I still buy & sell these NFTs on other marketplaces?
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          Yes! Once you buy the NFT it is yours - just like any NFT
          You can always trade on Opensea, but there is no guaranteed liquidity there
        </AccordionDetails>
      </Accordion>
    </div>
  )
}


export default BondingCurveAccordion;
